export const PurchasingGroupTemplateFormState = {
    NEW: "NEW",
    SENT: "SENT",
    VERIFIED: "VERIFIED",
    ASK_FOR_EDIT: "ASK_FOR_EDIT",
    EDIT: "EDIT"
}